<div class="glass-house-shelf-talker">
  <div class="glass-house-shelf-talker-header" [style.background-color]="viewModel.accentColor$ | push">
    <div class="header-title" [style.color]="viewModel.headerTextColor$ | push">
      {{ viewModel.headerText$ | push }}
    </div>
    <div class="logo-container">
      <img
        *rxIf="viewModel.companyLogo$ | push as logo; strategy: 'immediate'"
        appImage
        class="header-logo"
        [asset]="logo"
        alt="company logo"
        src="" />
    </div>
  </div>
  <div
    class="glass-house-shelf-talker-body"
    [style.color]="viewModel.bodyTextColor$ | push"
    [style.padding-top]="
      (viewModel.cardSize$ | push) === Types.ShelfTalkerCardSize.ShelfTalkerSize_Custom5x7 ? '0.625rem' : '0.25rem'
    "
    [style.padding-left]="
      (viewModel.cardSize$ | push) === Types.ShelfTalkerCardSize.ShelfTalkerSize_Custom5x7 ? '0.875rem' : '0.5rem'
    ">
    <div
      *rxFor="let rowVariants of viewModel.variantsSplitInto6Rows$; strategy: 'immediate'; let odd = odd"
      class="shelf-talker-row">
      <app-glass-house-shelf-talker-item
        *ngIf="rowVariants?.[0] as firstGrouping"
        [shelfTalkerCardData]="viewModel.data$ | push"
        [cardSize]="viewModel.cardSize$ | push"
        [variantsGroupedByBrand]="firstGrouping"
        [viewingInLiveView]="viewModel.viewingInLiveView$ | async" />
      <app-glass-house-shelf-talker-item
        *ngIf="rowVariants?.[1] as secondGrouping"
        [shelfTalkerCardData]="viewModel.data$ | push"
        [cardSize]="viewModel.cardSize$ | push"
        [variantsGroupedByBrand]="secondGrouping"
        [viewingInLiveView]="viewModel.viewingInLiveView$ | async" />
    </div>
  </div>
</div>
